import PrtIcon from '@/components/atoms/PrtIcon/PrtIcon.vue'
import casesPLMixin from '@/components/utils/mixins/casesPLMixin.js'
const casesPL = require('@/data/casesPL.json')
import vueScroll from 'vuescroll'
export default {
  name: 'PrtSidebar',
  components: {
    PrtIcon,
    vueScroll
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  // mixins: [casesPLMixin],

  computed: {
    totalsPL() {
      const o = {
        cases: this.items.reduce((acc, { infected }) => acc + infected, 0),
        deaths: this.items.reduce((acc, { deaths }) => acc + deaths, 0)
      }
      console.log(o)
      return o
    },
    sortedCites() {
      // console.log(this.items)
      return this.items.sort((a, b) => b.infected - a.infected)
    }
  },
  // watch: {
  //   items: function(newVal, oldVal) {
  //     // watch it
  //     console.log('Prop changed: ', newVal, ' | was: ', oldVal)
  //   }
  // },
  mounted() {},
  data() {
    return {
      scrollOpts: {
        vuescroll: { sizeStrategy: 'percent' },
        scrollPanel: {},
        rail: {
          background: '#01a99a',
          opacity: 0,
          size: '2px',
          specifyBorderRadius: false,
          gutterOfEnds: '5px',
          gutterOfSide: '2px',
          keepShow: false
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: false,
          keepShow: false,
          background: '#c1c1c1',
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: 0,
          size: '7px',
          disable: false
        }
      }
      //   totalsPL: this.getTotals(),
      // citiesPL: this.getCitiesPL()
    }
  }
}
